import { request } from './_request';
import moment from 'moment'


export const searchMetrico = (text) => {


	return (dispatch, getState) => {

		let registro = moment().subtract(1, "days").format("YYYY-MM-DD")

		let mainMetrico = getState().mainMetrico
		let secciones = JSON.parse(JSON.stringify(mainMetrico.secciones))

		secciones.forEach((sItem, sIndex) => {
			console.log('item',sItem)
			secciones[sIndex].metricos.forEach((mItem, mIndex) => {
				if (mItem.nombre.toLowerCase().includes(text.toLowerCase()) ||
					mItem.codigo.toLowerCase().includes(text.toLowerCase()) ||
					sItem.nombre.toLowerCase().includes(text.toLowerCase())  ) {
					secciones[sIndex].metricos[mIndex].estatus = 1
				} else {
					secciones[sIndex].metricos[mIndex].estatus = 0
				}

				if (text == "") {
					secciones[sIndex].metricos[mIndex].estatus = 1
				}
			})
		})

		dispatch({
			type: 'READY_MENU_MAIN_METRIC',
			payload: secciones
		});

	}
};

export const getMetrico = (idMarca, idUnidad, codigo) => {


	return (dispatch, getState) => {

		let registro = moment().subtract(1, "days").format("YYYY-MM-DD")

		let mainMetrico = getState().mainMetrico
		let secciones = mainMetrico.secciones

		dispatch({ type: 'LOADING_MAIN_METRIC', payload: true });
		const user = JSON.parse(localStorage.getItem('@@auth_user'));
		request
			.get('/metrico/main', { params: { codigo: mainMetrico.codeMetrico, idMarca: mainMetrico.idMarca, idUnidad: mainMetrico.idUnidad, registro: registro }, headers: { 'Authorization': `Bearer ${user.token}` } })
			.then((response) => {
				let data = response.data;

				if (!data.error) {

					dispatch({
						type: 'READY_DATA_MAIN_METRIC',
						payload: data.result
					});

					let itemS = null
					secciones.map((seccion, indexSection) => {
						seccion.metricos.map((item, indexItem) => {

							if (mainMetrico.codeMetrico == item.codigo) {
								itemS = item
							}
						})
					})

					if (itemS) {
						dispatch({
							type: 'CHANGE_METRICO_MAIN_METRIC',
							payload: {
								codigo: itemS.codigo,
								nombre: itemS.nombre,
								descripcion: itemS.descripcion,
								data: itemS.data,
								formato: itemS.valores.length > 0 ? itemS.valores[0].valor_formato : "",
								valor: itemS.valores.length > 0 ? itemS.valores[0].valor : ""
							}
						})
					}


				} else {

					if (data.code == -1) {
						localStorage.removeItem('@@auth_user');
						dispatch({
							type: 'ERROR_TOKEN_MAIN',
							payload: { message: data.message, code: -1 }
						})
						dispatch({
							type: 'ERROR_TOKEN_MAIN_METRIC',
							payload: data.message
						});
					} else {
						dispatch({
							type: 'ERROR_MAIN_METRIC',
							payload: data.message
						});
					}

				}
			})
			.catch((e) => {
				dispatch({
					type: 'ERROR_MAIN_METRIC',
					payload: e.message
				});
			});
	}
};


export const getData = (idMarca, idUnidad) => {


	return (dispatch, getState) => {

		let registro = moment().subtract(1, "days").format("YYYY-MM-DD")
		let mainMetrico = getState().mainMetrico

		dispatch({ type: 'LOADING_MAIN_METRIC', payload: true });
		const user = JSON.parse(localStorage.getItem('@@auth_user'));

		request
			.get('/metrico/data', { params: { codigo: mainMetrico.codeMetrico, idMarca: mainMetrico.idMarca, idUnidad: mainMetrico.idUnidad, registro: registro }, headers: { 'Authorization': `Bearer ${user.token}` } })
			.then((response) => {
				let data = response.data;

				if (!data.error) {


					dispatch({
						type: 'READY_DATA_TABLE_MAIN_METRIC',
						payload: data.result
					});

				} else {

					if (data.code == -1) {
						localStorage.removeItem('@@auth_user');
						dispatch({
							type: 'ERROR_TOKEN_MAIN',
							payload: { message: data.message, code: -1 }
						})
						dispatch({
							type: 'ERROR_TOKEN_MAIN_METRIC',
							payload: data.message
						});
					} else {
						dispatch({
							type: 'ERROR_MAIN_METRIC',
							payload: data.message
						});
					}

				}
			})
			.catch((e) => {
				dispatch({
					type: 'ERROR_MAIN_METRIC',
					payload: e.message
				});
			});
	}
};


export const globalData = (props) => {


	return (dispatch) => {

		return new Promise((ready) => {
			dispatch({ type: 'LOADING_MAIN_METRIC', payload: true });
			let registro = moment().subtract(1, "days").format("YYYY-MM-DD")

			const user = JSON.parse(localStorage.getItem('@@auth_user'));
			request
				.get('metrico/marcas', { params: { registro: registro }, headers: { 'Authorization': `Bearer ${user.token}` } })
				.then((response) => {
					let data = response.data;

					if (!data.error) {

						let secciones = fixPercents(data.result.secciones)
						let marcas = data.result.marcas

						dispatch({
							type: 'READY_GLOBAL_DATA_MAIN_METRIC',
							payload: data.result
						});


						if (marcas.length > 0) {
							let itemMarca = marcas[0]
							let itemUnidad = itemMarca.marcaUnidades.length > 0 ? itemMarca.marcaUnidades[0].unidad : {}

							dispatch({
								type: 'CHANGE_MARCA_MAIN_METRIC',
								payload: {
									idMarca: itemMarca.id, idUnidad: itemUnidad.id,
									nameMarca: itemMarca.nombre, nameUnidad: itemUnidad.nombre
								}
							});
						}



						dispatch({
							type: 'CHANGE_METRICO_MAIN_METRIC',
							payload: {
								codigo: secciones.length > 0 ? (secciones[0].metricos.length > 0 ? secciones[0].metricos[0].codigo : "") : "",
								nombre: secciones.length > 0 ? (secciones[0].metricos.length > 0 ? secciones[0].metricos[0].nombre : "") : "",
								descripcion: secciones.length > 0 ? (secciones[0].metricos.length > 0 ? secciones[0].metricos[0].descripcion : "") : "",
								data: secciones.length > 0 ? (secciones[0].metricos.length > 0 ? secciones[0].metricos[0].data : "") : "",
								formato: secciones.length > 0 ?
									(secciones[0].metricos.length > 0 ?
										(secciones[0].metricos[0].valores.length > 0 ?
											secciones[0].metricos[0].valores[0].valor_formato : "") : "") : "",
								valor: secciones.length > 0 ?
									(secciones[0].metricos.length > 0 ?
										(secciones[0].metricos[0].valores.length > 0 ?
											secciones[0].metricos[0].valores[0].valor : "") : "") : ""
							}
						})
						ready()
					} else {

						if (data.code == -1) {
							localStorage.clear()
							dispatch({
								type: 'ERROR_TOKEN_MAIN_METRIC',
								payload: data.message
							});
						} else {
							dispatch({
								type: 'ERROR_MAIN_METRIC',
								payload: data.message
							});
						}

					}
				})
				.catch((e) => {
					dispatch({
						type: 'ERROR_MAIN_METRIC',
						payload: e.message
					});
				});

		});
	}
};


export const getMetricosMenu = (idMarca, idUnidad) => {


	return (dispatch) => {
		return new Promise((ready) => {
			dispatch({ type: 'LOADING_MAIN_METRIC', payload: true });
			let registro = moment().subtract(1, "days").format("YYYY-MM-DD")

			const user = JSON.parse(localStorage.getItem('@@auth_user'));
			console.log(user)
			request
				.get('metrico/menu', { params: { idMarca: idMarca, idUnidad: idUnidad, registro }, headers: { 'Authorization': `Bearer ${user.token}` } })
				.then((response) => {

					let data = response.data

					if (!data.error) {
						let finalData = response.data.result
						if (idMarca === 0 || idUnidad == 0) {
							finalData = fixPercents(response.data.result)
						}
						dispatch({
							type: 'READY_MENU_MAIN_METRIC',
							payload: finalData
						});
						ready()

					} else {

						if (data.code == -1) {
							localStorage.clear()
							dispatch({
								type: 'ERROR_TOKEN_MAIN_METRIC',
								payload: data.message
							});
						} else {
							dispatch({
								type: 'ERROR_MAIN_METRIC',
								payload: data.message
							});
						}

					}
				})
				.catch((e) => {
					dispatch({
						type: 'ERROR_MAIN_METRIC',
						payload: e.message
					});
				});

		});
	}
};



export const changeMarca = (idMarca, idUnidad, nameMarca, nameUnidad) => {


	return (dispatch) => {

		dispatch({ type: 'CHANGE_MARCA_MAIN_METRIC', payload: { idMarca: idMarca, idUnidad: idUnidad, nameMarca: nameMarca, nameUnidad: nameUnidad } });

	}
};


export const changeMetrico = (item) => {


	return (dispatch) => {
		return new Promise((ready) => {
			dispatch({
				type: 'CHANGE_METRICO_MAIN_METRIC',
				payload: {
					codigo: item.codigo,
					nombre: item.nombre,
					descripcion: item.descripcion,
					data: item.data,
					formato: item.valores.length > 0 ? item.valores[0].valor_formato : "",
					valor: item.valores.length > 0 ? item.valores[0].valor : ""
				}
			});
			ready()
		});
	}
};


function fixPercents(data) {


	let mainValue = {}
	for (let i = 0; i < data.length; i++) {

		for (let j = 0; j < data[i].metricos.length; j++) {
			if (data[i].metricos[j].valores.length > 0) {
				mainValue[data[i].metricos[j].codigo] = data[i].metricos[j].valores[0].valor
			}

		}
	}


	for (let i = 0; i < data.length; i++) {

		for (let j = 0; j < data[i].metricos.length; j++) {

			switch (data[i].metricos[j].codigo) {
				case "AN007":
					if (data[i].metricos[j].valores.length > 0) {
						data[i].metricos[j].valores[0].valor = 0
						if (mainValue.hasOwnProperty("AN012") && mainValue.hasOwnProperty("AN011") && mainValue.hasOwnProperty("AN013")) {
							data[i].metricos[j].valores[0].valor = (mainValue["AN012"] - mainValue["AN013"]) / mainValue["AN011"]
						}
					}

					break
				case "AN002":
					if (data[i].metricos[j].valores.length > 0) {
						data[i].metricos[j].valores[0].valor = 0
						if (mainValue.hasOwnProperty("AN009") && mainValue.hasOwnProperty("AN010")) {
							data[i].metricos[j].valores[0].valor = 100 * (mainValue["AN009"] - mainValue["AN010"]) / mainValue["AN009"]
						}
					}

					break
				case "AN015":
					if (data[i].metricos[j].valores.length > 0) {
						data[i].metricos[j].valores[0].valor = 0
						if (mainValue.hasOwnProperty("AN012") && mainValue.hasOwnProperty("AN013")) {
							data[i].metricos[j].valores[0].valor = 100 * (mainValue["AN012"] - mainValue["AN013"]) / mainValue["AN012"]
						}
					}

					break

				case "AS005":
					if (data[i].metricos[j].valores.length > 0) {
						data[i].metricos[j].valores[0].valor = 0
						if (mainValue.hasOwnProperty("AS004") && mainValue.hasOwnProperty("AS007")) {
							data[i].metricos[j].valores[0].valor = 100 * (mainValue["AS004"] - mainValue["AS007"]) / mainValue["AS004"]
						}
					}

					break

				default:
			}


		}
	}
	return data

}